const StorageUtils = (function () {
  // Private variables
  let isLocalStorageAvail = null;

  return {
    // Determines whether Local Storage is supported in the current browser
    isStorageAvailable(type) {
      try {
        var storage = window[type];
        const x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
      } catch (e) {
        return (
          e instanceof DOMException &&
          // everything except Firefox
          (e.code === 22 ||
            // Firefox
            e.code === 1014 ||
            // test name field too, because code might not be present
            // everything except Firefox
            e.name === 'QuotaExceededError' ||
            // Firefox
            e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
          // acknowledge QuotaExceededError only if there's something already stored
          storage.length !== 0
        );
      }
    },

    // Stores a key/value pair in the local storage, if availalble. Returns true if data
    // was successfully stored or false otherwise
    setInLocalStorage(key, value) {
      if (isLocalStorageAvail === null) {
        isLocalStorageAvail = this.isStorageAvailable('localStorage');
      }

      if (isLocalStorageAvail) {
        localStorage.setItem(key, value);
        return true;
      }

      return false;
    },

    // Retrieves the value associated with the specified key from the local storage.
    // Returns null if local storage is not available or the key wasn't there
    getFromLocalStorage(key) {
      if (isLocalStorageAvail === null) {
        isLocalStorageAvail = this.isStorageAvailable('localStorage');
      }

      if (isLocalStorageAvail) {
        return localStorage.getItem(key);
      }

      return null;
    },
  };
})();

export default StorageUtils;
